import { loadedInitSelector } from "appredux/selectors";
import { useSelector } from "react-redux";
import Skeleton from "./skeleton";
import { Card } from "antd";

const PageContent = ({ children, ...props }) => {
  const loadedInit = useSelector(loadedInitSelector);

  return (
    <div className="p-6 pt-0" {...props}>
      {!loadedInit ? (
        <Card>
          <Skeleton />
        </Card>
      ) : (
        children
      )}
      {/* {children} */}
    </div>
  );
};

export default PageContent;
